import React from 'react';
import { useIntl, FormattedMessage, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import { INTL_NUMBER_UNIT_DISPLAY_SHORT } from './intl-unit-formatting-service';

const messages = defineMessages({
  dimensions: {
    description: 'Dimensions unit number e.g. 1in X 2in X 3in',
    defaultMessage: '{length} X {width} X {height}',
    id: '1Y03Md',
  },
});

export const DimensionFormattedMessage = ({ length, width, height, unit }) => {
  const intl = useIntl();
  const intlFormat = {
    unit,
    style: 'unit',
    unitDisplay: INTL_NUMBER_UNIT_DISPLAY_SHORT,
    maximumFractionDigits: 2,
  };

  return (
    <FormattedMessage
      {...messages.dimensions}
      values={{
        length: intl.formatNumber(length, intlFormat),
        width: intl.formatNumber(width, intlFormat),
        height: intl.formatNumber(height, intlFormat),
      }}
    />
  );
};

DimensionFormattedMessage.propTypes = {
  length: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
};
